// extracted by mini-css-extract-plugin
export default {"mobileVert":"mobileVert--jb7rt"};